module.exports = __webpack_public_path__ + "img/device_c9_one_en.3b7eb69a.png";